import React, { useState, useMemo } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { useApolloClient, useQuery } from "react-apollo";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Content, Button, Control, Field, Label, Input, Icon } from "rbx";
import { ourToast as toast } from "../../../../../utils";
import {
  CLOSE_POSTING_PERIOD,
  ALL_COMPANY_POSTING_PERIODS_QUERY
} from "../../../../../graphql/CompanyPostingPeriods/CompanyPostingPeriods.graphql";

const OpenPeriodModal = ({ onComplete, companyPostingPeriod }) => {
  const { data, loading: loadingData } = useQuery(
    ALL_COMPANY_POSTING_PERIODS_QUERY,
    {
      variables: {}
    }
  );
  const client = useApolloClient();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");

  const currentMoth = new Date().getMonth();
  const PeriodEndDateTime = new Date(companyPostingPeriod.PeriodEndDateTime);
  const openPeriod = data?.CompanyPostingPeriods?.find(
    p => p.Open && p.ModuleRecIdRef === companyPostingPeriod.ModuleRecIdRef
  );
  const handleCancel = () => {
    onComplete();
  };

  const onConfirm = async () => {
    try {
      setLoading(true);
      await client.mutate({
        mutation: CLOSE_POSTING_PERIOD,
        variables: {
          PreviousId: openPeriod?.RecId,
          NextId: companyPostingPeriod.RecId,
          Password: password,
          CompanyId: localStorage.getItem("user_company")
        },
        refetchQueries: ["ALL_COMPANY_POSTING_PERIODS_QUERY"]
      });
      onComplete();
    } catch (err) {
      toast.error("Error Posting Periods.");
    } finally {
      setLoading(false);
    }
  };

  const message = useMemo(() => {
    if (currentMoth >= PeriodEndDateTime.getMonth()) {
      return `Are you sure you want to open ${
        companyPostingPeriod?.Module?.CodeDescription
      } period for ${moment(companyPostingPeriod.PeriodEndDateTime).format(
        "MM/DD/YYYY"
      )}? ${
        openPeriod
          ? `This will close current open period for ${moment(
              openPeriod.PeriodEndDateTime
            ).format("MM/DD/YYYY")}.`
          : ""
      }`;
    }
    return `The ${
      companyPostingPeriod?.Module?.CodeDescription
    } period for ${moment(PeriodEndDateTime).format(
      "MM/DD/YYYY"
    )} cannot be opened because is after the current date.`;
  }, [
    PeriodEndDateTime,
    companyPostingPeriod.Module.CodeDescription,
    companyPostingPeriod.PeriodEndDateTime,
    currentMoth,
    openPeriod
  ]);

  const toggleShowPassword = e => {
    e.preventDefault();
    e.stopPropagation();
    setShowPassword(!showPassword);
  };

  return (
    <div style={{ width: 400, margin: "0 auto", padding: 5 }}>
      <Content size="medium" textAlign="centered">
        <p>{message}</p>
        {currentMoth >= PeriodEndDateTime.getMonth() && (
          <Field>
            <Control expanded>
              <Label className="UpdatePasswordModalLabel">Password</Label>
              <Field kind="addons">
                <Control expanded>
                  <Input
                    required
                    className="password"
                    maxLength={250}
                    name="password"
                    placeholder="Password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={e => {
                      setPassword(e.target.value);
                    }}
                  />
                </Control>
                <Control>
                  <Button
                    className="input UpdatePasswordModalToggleShowButton"
                    color="info"
                    tabIndex="-1"
                    onClick={toggleShowPassword}
                  >
                    <Icon>
                      <FontAwesomeIcon
                        icon={showPassword ? "eye" : "eye-slash"}
                      />
                    </Icon>
                  </Button>
                </Control>
              </Field>
            </Control>
          </Field>
        )}
      </Content>

      <Field align="centered" kind="group">
        {currentMoth >= PeriodEndDateTime.getMonth() && (
          <Control>
            <Button
              color="success"
              disabled={currentMoth < PeriodEndDateTime.getMonth() || !password}
              state={loading || loadingData ? "loading" : ""}
              onClick={onConfirm}
            >
              Process
            </Button>
          </Control>
        )}
        <Control>
          <Button color="danger" disabled={loading} onClick={handleCancel}>
            Cancel
          </Button>
        </Control>
      </Field>
    </div>
  );
};

OpenPeriodModal.propTypes = {
  onComplete: PropTypes.func,
  companyPostingPeriod: PropTypes.object
};
export default OpenPeriodModal;
